import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { TimeLeft } from "@/helpers/waves/time.utils";
import { TimeUnitDisplay } from "./TimeUnitDisplay";
interface CompactTimeCountdownProps {
  readonly timeLeft: TimeLeft;
  readonly label?: string | undefined;
}

/**
 * Displays a compact countdown with time units inline
 * Used in tab headers and other space-constrained areas
 */
export const CompactTimeCountdown: React.FC<CompactTimeCountdownProps> = t0 => {
  const $ = _c(14);
  const {
    timeLeft
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-text-iron-300 tw-font-medium tw-whitespace-nowrap">Next winner:</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== timeLeft.days) {
    t2 = timeLeft.days > 0 && <TimeUnitDisplay value={timeLeft.days} label="days" />;
    $[1] = timeLeft.days;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== timeLeft.hours) {
    t3 = <TimeUnitDisplay value={timeLeft.hours} label="hrs" />;
    $[3] = timeLeft.hours;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== timeLeft.minutes) {
    t4 = <TimeUnitDisplay value={timeLeft.minutes} label="min" />;
    $[5] = timeLeft.minutes;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== timeLeft.seconds) {
    t5 = <TimeUnitDisplay value={timeLeft.seconds} label="sec" />;
    $[7] = timeLeft.seconds;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className="tw-hidden md:tw-inline-flex tw-items-center tw-gap-1.5 tw-text-xxs tw-font-medium tw-text-iron-300">{t1}<div className="tw-flex tw-items-center tw-gap-x-1.5">{t2}{t3}{t4}{t5}</div></div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};